// src/components/BrowserNotifications/index.js
import Notify from 'notifyjs';

const baseIcon = process.env.REACT_APP_BASE_NAME || '';

/**
 * Dispara uma notificação de desktop usando Notify.js,
 * solicitando permissão apenas quando necessário.
 *
 * @param {{ title?: string, body?: string }} options
 */
export default function notification({
  title = 'TECNOZAP',
  body = 'Você tem uma nova mensagem',
}) {
  // 1) Verifica se a API de Notifications existe
  if (!('Notification' in window)) {
    console.warn('Notification API não suportada neste navegador');
    return;
  }

  // 2) Se ainda não deu permissão, solicita e, só se for concedida, mostra
  if (Notification.permission === 'default') {
    Notification.requestPermission()
      .then((permission) => {
        if (permission === 'granted') {
          const notifGranted = new Notify(title, {
            body,
            icon: `${baseIcon}/static/icons/new-icon-tecnozap.svg`,
            requireInteraction: true,
            closeOnClick: true,
            notifyClick(e) {
              e.preventDefault();
              window.focus();
              notifGranted.close();
            },
          });
          notifGranted.show();
        }
      })
      .catch((err) => console.error('Erro ao solicitar permissão:', err));
    return;
  }

  // 3) Se negado, não faz nada
  if (Notification.permission === 'denied') {
    console.warn('Permissão de notificação negada pelo usuário');
    return;
  }

  // 4) Se já tem permissão, dispara imediatamente
  const notif = new Notify(title, {
    body,
    icon: `${baseIcon}/static/icons/new-icon-tecnozap.svg`,
    requireInteraction: true,
    closeOnClick: true,
    notifyClick(e) {
      e.preventDefault();
      window.focus();
      notif.close();
    },
  });
  notif.show();
}
